(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[764],{

/***/ 8892:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(7294);

function BriefcaseIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M20.25 14.15v4.25c0 1.094-.787 2.036-1.872 2.18-2.087.277-4.216.42-6.378.42s-4.291-.143-6.378-.42c-1.085-.144-1.872-1.086-1.872-2.18v-4.25m16.5 0a2.18 2.18 0 00.75-1.661V8.706c0-1.081-.768-2.015-1.837-2.175a48.114 48.114 0 00-3.413-.387m4.5 8.006c-.194.165-.42.295-.673.38A23.978 23.978 0 0112 15.75c-2.648 0-5.195-.429-7.577-1.22a2.016 2.016 0 01-.673-.38m0 0A2.18 2.18 0 013 12.489V8.706c0-1.081.768-2.015 1.837-2.175a48.111 48.111 0 013.413-.387m7.5 0V5.25A2.25 2.25 0 0013.5 3h-3a2.25 2.25 0 00-2.25 2.25v.894m7.5 0a48.667 48.667 0 00-7.5 0M12 12.75h.008v.008H12v-.008z"
  }));
}

const ForwardRef = React.forwardRef(BriefcaseIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 6741:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(7294);

function MapIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9 6.75V15m6-6v8.25m.503 3.498l4.875-2.437c.381-.19.622-.58.622-1.006V4.82c0-.836-.88-1.38-1.628-1.006l-3.869 1.934c-.317.159-.69.159-1.006 0L9.503 3.252a1.125 1.125 0 00-1.006 0L3.622 5.689C3.24 5.88 3 6.27 3 6.695V19.18c0 .836.88 1.38 1.628 1.006l3.869-1.934c.317-.159.69-.159 1.006 0l4.994 2.497c.317.158.69.158 1.006 0z"
  }));
}

const ForwardRef = React.forwardRef(MapIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 3410:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cases/newmancollege",
      function () {
        return __webpack_require__(8933);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 758:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/app.fb4e806b.png","height":1008,"width":2120,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAMAAACEE47CAAAAD1BMVEX9/f35+frz9PXp6uzR0tYpJC/lAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAIUlEQVR4nB3IwREAMAiAMED3n7lnfwQmLaEG8Gq/se3WAwNQACsU3pZvAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":4});

/***/ }),

/***/ 2605:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/email.b92485c1.png","height":1541,"width":1146,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAMAAADtGH4KAAAAGFBMVEX09fj+/v/6+vrv8PLN4vCZxOHb6/W01estfp6NAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAK0lEQVR4nBXKwREAMAiEQDg19t9xxg8fFkoVqkACxEsi9kyLb/cdyb0j+gEIuABXoFJD3AAAAABJRU5ErkJggg==","blurWidth":6,"blurHeight":8});

/***/ }),

/***/ 4973:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/milou.e4fa879a.jpg","height":3336,"width":2866,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAIAAcDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAT/xAAdEAACAgMAAwAAAAAAAAAAAAABAgADBAUREiGR/8QAFQEBAQAAAAAAAAAAAAAAAAAAAgT/xAAaEQACAgMAAAAAAAAAAAAAAAABAgADBBEh/9oADAMBAAIRAxEAPwC3T5mTZuUpW1rLbC/mGcnqgdHz0IiIMdAybMouchuT/9k=","blurWidth":7,"blurHeight":8});

/***/ }),

/***/ 2106:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/newman.aaf87862.jpg","height":865,"width":1600,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAEAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAb/xAAeEAACAQMFAAAAAAAAAAAAAAABAgADETEEBQYSIf/EABUBAQEAAAAAAAAAAAAAAAAAAAQF/8QAFxEBAQEBAAAAAAAAAAAAAAAAAQAhMf/aAAwDAQACEQMRAD8AlRzPeBpqpZqDs46ljSFwPcWxERKhvYqBf//Z","blurWidth":8,"blurHeight":4});

/***/ }),

/***/ 6055:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/newman2.f09055f6.jpg","height":1200,"width":1600,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAGAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAT/xAAeEAABBAEFAAAAAAAAAAAAAAAAAQIEERIFEyEy0f/EABUBAQEAAAAAAAAAAAAAAAAAAAAD/8QAGhEAAgIDAAAAAAAAAAAAAAAAAQIAAxEhQf/aAAwDAQACEQMRAD8AsdIkNvWVwVmdbfPbwAFqHbDb6YuUZGuCf//Z","blurWidth":8,"blurHeight":6});

/***/ }),

/***/ 8391:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Kx": function() { return /* binding */ TextArea; },
/* harmony export */   "nv": function() { return /* binding */ TextField; }
/* harmony export */ });
/* unused harmony export SelectField */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);


const formClasses = "block w-full appearance-none rounded-md border border-gray-200 bg-gray-50 px-3 py-2 text-gray-900 placeholder-gray-400 focus:border-blue-500 focus:bg-white focus:outline-none focus:ring-blue-500 sm:text-sm";
function Label(param) {
    let { id , children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
        htmlFor: id,
        className: "mb-3 block text-sm font-medium text-gray-700",
        children: children
    });
}
function TextField(param) {
    let { id , label , type ="text" , className ="" , register , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: className,
        children: [
            label && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Label, {
                id: id,
                children: label
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                id: id,
                type: type,
                ...register,
                ...props,
                className: formClasses
            })
        ]
    });
}
function TextArea(param) {
    let { id , label , className ="" , register , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: className,
        children: [
            label && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Label, {
                id: id,
                children: label
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("textarea", {
                id: id,
                ...register,
                ...props,
                className: formClasses
            })
        ]
    });
}
function SelectField(param) {
    let { id , label , className ="" , ...props } = param;
    return /*#__PURE__*/ _jsxs("div", {
        className: className,
        children: [
            label && /*#__PURE__*/ _jsx(Label, {
                id: id,
                children: label
            }),
            /*#__PURE__*/ _jsx("select", {
                id: id,
                ...props,
                className: clsx(formClasses, "pr-8")
            })
        ]
    });
}


/***/ }),

/***/ 3172:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Office; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/24/outline/MapIcon.js
var MapIcon = __webpack_require__(6741);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/24/outline/BriefcaseIcon.js
var BriefcaseIcon = __webpack_require__(8892);
// EXTERNAL MODULE: ./src/components/Fields.jsx
var Fields = __webpack_require__(8391);
// EXTERNAL MODULE: ./src/components/Button.jsx
var Button = __webpack_require__(1109);
;// CONCATENATED MODULE: ./src/images/office.jpg
/* harmony default export */ var office = ({"src":"/_next/static/media/office.81684f07.jpg","height":1733,"width":2600,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAFAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAT/xAAcEAACAgMBAQAAAAAAAAAAAAABAgADBAUREiH/xAAUAQEAAAAAAAAAAAAAAAAAAAAC/8QAFxEAAwEAAAAAAAAAAAAAAAAAAAECQf/aAAwDAQACEQMRAD8AiwNLiPubFepHbHYVrY3oseAnpPfpiIgSFWH/2Q==","blurWidth":8,"blurHeight":5});
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./src/components/Office.jsx






function Office() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative bg-white",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "lg:absolute lg:inset-0",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "lg:absolute lg:inset-y-0 lg:right-0 lg:w-1/2",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        className: "h-56 w-full object-cover lg:absolute lg:h-full",
                        src: office,
                        alt: "Kantoor"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "relative py-16 px-6 sm:py-24 lg:mx-auto lg:grid lg:max-w-7xl lg:grid-cols-2 lg:px-8 lg:py-32",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "lg:pr-8",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mx-auto max-w-md sm:max-w-lg lg:mx-0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    className: "text-2xl font-bold text-gray-900 sm:text-3xl sm:tracking-tight font-display",
                                    children: "Bedrijfsgegevens"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mt-3",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-lg text-gray-500",
                                        children: "Graag een keer langskomen? Wij zijn gevestigd in 's-Hertogenbosch."
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "mt-9",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "flex-shrink-0",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MapIcon, {
                                                        className: "h-6 w-6 text-gray-400",
                                                        "aria-hidden": "true"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "ml-3 text-base text-gray-500",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "font-semibold",
                                                            children: "The Lobby"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "mt-1",
                                                            children: "Reitscheweg 1"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "mt-1",
                                                            children: "'s-Hertogenbosch"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "mt-1",
                                                            children: "5232 BX"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "mt-6 flex",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "flex-shrink-0",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BriefcaseIcon, {
                                                        className: "h-6 w-6 text-gray-400",
                                                        "aria-hidden": "true"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "ml-3 text-base text-gray-500",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            children: "KVK: 87979284"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "mt-1",
                                                            children: "BTW: NL864465695B01"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            })
        ]
    });
}


/***/ }),

/***/ 8933:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Newmancollege; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2962);
/* harmony import */ var _components_Header__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7027);
/* harmony import */ var _components_HeaderSimple__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2055);
/* harmony import */ var _components_Team__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7947);
/* harmony import */ var _components_Office__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3172);
/* harmony import */ var _components_CallToAction__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4778);
/* harmony import */ var _components_Footer__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(3862);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _images_cases_newman_milou_jpg__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(4973);
/* harmony import */ var _images_cases_newman_newman_jpg__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(2106);
/* harmony import */ var _images_cases_newman_newman2_jpg__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(6055);
/* harmony import */ var _images_cases_newman_email_png__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(2605);
/* harmony import */ var _images_cases_newman_app_png__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(758);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_14__);















function Newmancollege() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_1__/* .NextSeo */ .PB, {
                title: "Interview Milou Boelen, Newmancollega in Breda",
                description: "Het Newmancollege in Breda gebruikt Bijlesplein met volle tevredenheid. Docent Milou Boelen vertelt over de tijdsbesparing en andere voordelen van Bijlesplein."
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Header__WEBPACK_IMPORTED_MODULE_2__/* .Header */ .h, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("main", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "bg-white px-6 py-10 lg:py-24 lg:px-8",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "mx-auto max-w-6xl text-base leading-7 text-gray-700 grid grid-cols-1 lg:grid-cols-2 gap-8",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "text-base font-semibold leading-7 text-blue-600",
                                                children: "Interview Milou Boelen, Newmancollega in Breda"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                                className: "mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl",
                                                children: "“Door de vrijgekomen tijd heb ik meer contact met leerlingen om de kwaliteit te verbeteren”"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "mt-6 text-lg leading-8",
                                                children: "“We deden het al 8 jaar op de ‘Excel-manier’.” Het gaat hier over het organiseren van bijles. We spreken met Milou Boelen, docent Nederlands op het Newmancollege in Breda. Ze werkt hier al zo’n 10 jaar en geeft vooral les aan de bovenbouw. Vanaf haar tweede jaar bij het Newmancollege is ze verantwoordelijk voor de BBO, ‘Bovenbouw begeleidt Onderbouw’. “Dat was dus een Excelsheet met namen en dan koppelde ik leerlingen die een match waren. Dat was veel administratie, navragen en regelwerk.” Sinds 2 jaar maakt het ‘Newman’ gebruik van Bijlesplein. Milou vertelt in dit interview de ervaringen die zij en haar school hebben met ons platform."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "relative",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "relative mx-auto max-w-prose text-base lg:max-w-none",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("figure", {
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "aspect-h-12 aspect-w-12 lg:aspect-none",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_8___default()), {
                                                            className: "rounded-lg object-cover object-center shadow-lg",
                                                            src: _images_cases_newman_milou_jpg__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z,
                                                            alt: "Milou Boelen"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("figcaption", {
                                                        className: "mt-3 flex text-sm text-gray-500",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                                                className: "h-5 w-5 flex-none text-gray-400",
                                                                viewBox: "0 0 20 20",
                                                                fill: "currentColor",
                                                                "aria-hidden": "true",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                                    fillRule: "evenodd",
                                                                    d: "M1 8a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 018.07 3h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0016.07 6H17a2 2 0 012 2v7a2 2 0 01-2 2H3a2 2 0 01-2-2V8zm13.5 3a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zM10 14a3 3 0 100-6 3 3 0 000 6z",
                                                                    clipRule: "evenodd"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                className: "ml-2",
                                                                children: "Foto van Milou Boelen"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "mx-auto max-w-3xl text-base leading-7 text-gray-700",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "mt-10 max-w-2xl",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                            className: "text-2xl font-bold tracking-tight text-gray-900",
                                            children: "Hoe zijn jullie bij Bijlesplein terecht gekomen?"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "mt-6",
                                            children: "Het stimuleren van begeleiding en bijles tussen leerlingen onderling is niet nieuw voor deze school. Niet gek, want tutoring heeft een positief effect op de leerprestaties, het zelfbeeld en metacognitieve vaardigheden. (bron: Onderwijkskennis)"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "mt-8",
                                            children: "“De BBO vroeg veel administratie en tijd, dat accepteerden we min of meer. Het was de manier waarop we dat deden. Toen Frits (Timmermans red.) van Bijlesplein ons benaderde, was de eerste gedachte ‘maar we doen dit toch al?’. Totdat hij liet zien wat het platform inhoudt, en hoe dat voor onze school zou werken. Dit overtuigde me dat het heel veel tijd zou schelen.”"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "mt-8",
                                            children: "“Ik was zoveel uren kwijt om leerlingen aan elkaar koppelen. Terwijl je die tijd veel liever wil steken in de kwaliteit van de tutoring bijvoorbeeld. Die ruimte was er helemaal niet. Ik was alleen maar met de randvoorwaarden bezig. Dus toen ik het zag, dacht ik wel dat Bijlesplein heel erg zou kunnen helpen.”"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("figure", {
                                            className: "mt-16",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_8___default()), {
                                                    className: "aspect-video rounded-xl bg-gray-50 object-cover",
                                                    src: _images_cases_newman_newman_jpg__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z,
                                                    alt: "Het Newmancollege"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("figcaption", {
                                                    className: "mt-4 flex gap-x-2 text-sm leading-6 text-gray-500",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                                            className: "mt-0.5 h-5 w-5 flex-none text-gray-300",
                                                            viewBox: "0 0 20 20",
                                                            fill: "currentColor",
                                                            "aria-hidden": "true",
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                                fillRule: "evenodd",
                                                                d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a.75.75 0 000 1.5h.253a.25.25 0 01.244.304l-.459 2.066A1.75 1.75 0 0010.747 15H11a.75.75 0 000-1.5h-.253a.25.25 0 01-.244-.304l.459-2.066A1.75 1.75 0 009.253 9H9z",
                                                                clipRule: "evenodd"
                                                            })
                                                        }),
                                                        "Het Newmancollege"
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                            className: "mt-16 text-2xl font-bold tracking-tight text-gray-900",
                                            children: "Wat was de belangrijkste reden om ermee te starten?"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "mt-8",
                                            children: "Bijlesplein is begonnen met het draaien van een pilot. “Die hebben we verlengd, omdat we heel enthousiast zijn over hoe het werkt.”"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "mt-8",
                                            children: "De belangrijkste reden voor het Newmancollege om met Bijlesplein te gaan werken, is het verminderen van de administratieve last. Het platform zorgt ervoor dat leerlingen elkaar vinden, dat hoef je als school niet meer te doen. “Ik ken natuurlijk niet alle leerlingen. Dus dan was ik linkjes aan het maken tussen leerlingen die ik helemaal niet ken. Die verantwoordelijkheid hebben ze nu zelf. En vaak kennen ze elkaar wel.”"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "mt-8",
                                            children: "“Ik merk ook dat ze heel kritisch zijn van wie ze bijles krijgen bijvoorbeeld. Dat is goed en ze kunnen nu zelf makkelijk de keuze maken. Dat kan ik niet voor ze doen.”"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                            className: "mt-16 text-2xl font-bold tracking-tight text-gray-900",
                                            children: "Leerlingen kunnen elkaar opzoeken, hoe werkt dat in de praktijk?"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "mt-8",
                                            children: "Om te beginnen, leerlingen die zich aanmelden om bijles te geven, moeten wel goed zijn in het vak. “Het cijfer zegt hierin niet altijd alles. Het kan best zijn dat een leerling in de bovenbouw niet goed is in wiskunde, maar in de onderbouw wel. Als ze lesgeven aan onderbouw is dat goed. Als school geven we goedkeuring of een leerling mag tutoren. We merken wel dat het lastig is snelheid te houden in de goedkeuring. Een leerling meldt zich aan, dan moet ik checken of dat een goede leerling is om bijles te geven voor dat vak. Dat proces is soms wel lang. Maar daar ligt meer een uitdaging voor onszelf, niet bij Bijlesplein.”"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "mt-8",
                                            children: "“Wat ik leuk vind, is dat het een soort marktplaats is waar de leerlingen opstaan. Ze kunnen zelf een profiel aanmaken en zichzelf presenteren. In de opstartfase zag je nog wel een paar leerlingen die zich voor de grap aanmeldde. Dat hadden we snel genoeg in de gaten en was van korte duur. Al snel zag je alleen serieuze aanmeldingen, die we nog steeds controleren, maar in de praktijk blijkt dat dat meestal een formaliteit is.”"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "mt-8",
                                            children: "“In de praktijk zien we dat sommige leerlingen in de afwachtende houding blijven. Terwijl ze elkaar moeten opzoeken. Of je bijles wil geven of juist krijgen, je kunt altijd de eerste stap zetten. We houden dat in de gaten en stimuleren daarom contact met elkaar op te nemen. We hebben het er met Bijlesplein al over gehad om bijvoorbeeld een melding te sturen wanneer er een mogelijke match is. We hebben dat overlegd en inmiddels is dit ingevoerd.”"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("figure", {
                                            className: "mt-16",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_8___default()), {
                                                    className: "aspect-video rounded-xl bg-gray-50 object-cover border",
                                                    src: _images_cases_newman_email_png__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z,
                                                    alt: "Melding die leerlingen ontvangen wanneer er een mogelijke match is."
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("figcaption", {
                                                    className: "mt-4 flex gap-x-2 text-sm leading-6 text-gray-500",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                                            className: "mt-0.5 h-5 w-5 flex-none text-gray-300",
                                                            viewBox: "0 0 20 20",
                                                            fill: "currentColor",
                                                            "aria-hidden": "true",
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                                fillRule: "evenodd",
                                                                d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a.75.75 0 000 1.5h.253a.25.25 0 01.244.304l-.459 2.066A1.75 1.75 0 0010.747 15H11a.75.75 0 000-1.5h-.253a.25.25 0 01-.244-.304l.459-2.066A1.75 1.75 0 009.253 9H9z",
                                                                clipRule: "evenodd"
                                                            })
                                                        }),
                                                        "Melding die leerlingen ontvangen wanneer er een mogelijke match is."
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "mt-8",
                                            children: "Op het Newmancollege zitten zo’n 1300 leerlingen waarvan er 270 aangemeld zijn op Bijlesplein. Alleen bovenbouw-leerlingen mogen bijles geven. “Wij zijn heel tevreden met dit aantal. Het platform is opgebouwd voor BBO, maar we zien steeds meer bovenbouw-leerlingen die bijles willen krijgen. En waarom niet. Je ziet dat dit platform het zo makkelijk maakt, dat dat ook heel goed kan.”"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("figure", {
                                            className: "mt-16",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_8___default()), {
                                                    className: "aspect-video rounded-xl bg-gray-50 object-cover",
                                                    src: _images_cases_newman_newman2_jpg__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z,
                                                    alt: "Leerlingen op het Newmancollege"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("figcaption", {
                                                    className: "mt-4 flex gap-x-2 text-sm leading-6 text-gray-500",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                                            className: "mt-0.5 h-5 w-5 flex-none text-gray-300",
                                                            viewBox: "0 0 20 20",
                                                            fill: "currentColor",
                                                            "aria-hidden": "true",
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                                fillRule: "evenodd",
                                                                d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a.75.75 0 000 1.5h.253a.25.25 0 01.244.304l-.459 2.066A1.75 1.75 0 0010.747 15H11a.75.75 0 000-1.5h-.253a.25.25 0 01-.244-.304l.459-2.066A1.75 1.75 0 009.253 9H9z",
                                                                clipRule: "evenodd"
                                                            })
                                                        }),
                                                        "Leerlingen op het Newmancollege"
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                            className: "mt-16 text-2xl font-bold tracking-tight text-gray-900",
                                            children: "Wat zijn de ervaringen van de leerlingen?"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "mt-8",
                                            children: "“We hebben niet concreet in beeld of bijvoorbeeld cijfers omhoog zijn gegaan. We horen wel veel positieve geluiden van leerlingen zelf. Je hoort dan ‘Ik hoop dat ik volgend jaar weer bijles van die persoon kan krijgen, want ik heb geen onvoldoendes meer voor dat vak’. Maar dat zijn losse verhalen en is niet gebaseerd op data. Gevoelsmatig denk ik wel dat het effect heeft. De data die we wel hebben zijn de reviews op Bijlesplein, die zijn voornamelijk positief.”"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "mt-8",
                                            children: "“Het platform wordt vooral gebruikt om elkaar te vinden. Verdere communicatie verloopt dan 1 op 1 via Whatsapp bijvoorbeeld. En ook het sturen van een Tikkie doen zij onderling. Logisch, want dat is makkelijk. Maar daardoor weten wij minder van wat er gebeurt en hoeveel matches er bijvoorbeeld zijn gemaakt of hoeveel lessen iemand heeft gegeven of gekregen. Informatie die voor ons interessant is, maar voor het doel van het matchen van bijles niet relevant. We zien en horen dat er veel gebruik van wordt gemaakt.”"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "mt-8",
                                            children: "Bijlesplein is altijd in ontwikkeling. Op dit moment wordt er gewerkt aan de zichtbaarheid van de data. Bijvoorbeeld in het aantal matches:"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("figure", {
                                            className: "mt-16",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_8___default()), {
                                                    className: "aspect-video rounded-xl bg-gray-50 object-cover",
                                                    src: _images_cases_newman_app_png__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z,
                                                    alt: "Schermopname uit het beheerpaneel"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("figcaption", {
                                                    className: "mt-4 flex gap-x-2 text-sm leading-6 text-gray-500",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                                            className: "mt-0.5 h-5 w-5 flex-none text-gray-300",
                                                            viewBox: "0 0 20 20",
                                                            fill: "currentColor",
                                                            "aria-hidden": "true",
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                                fillRule: "evenodd",
                                                                d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a.75.75 0 000 1.5h.253a.25.25 0 01.244.304l-.459 2.066A1.75 1.75 0 0010.747 15H11a.75.75 0 000-1.5h-.253a.25.25 0 01-.244-.304l.459-2.066A1.75 1.75 0 009.253 9H9z",
                                                                clipRule: "evenodd"
                                                            })
                                                        }),
                                                        "Schermopname uit het beheerpaneel."
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                            className: "mt-16 text-2xl font-bold tracking-tight text-gray-900",
                                            children: "Zie je met Bijlesplein kans om kansenongelijkheid te verkleinen?"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "mt-8",
                                            children: "“Kansenongelijkheid is natuurlijk een thema waar we ons heel bewust van zijn. Het is moeilijk in beeld te brengen, want veel leerlingen willen zelf niet in beeld zijn. Het scheelt als je de samenwerking met de gemeente aan kan gaan, want daar is veel meer bekend.”"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "mt-8",
                                            children: "“Wij hebben voor iedereen hetzelfde tarief bepaald van maximaal €5. Ongeacht aantal jaar ervaring of betere beoordeling. Met de gedachte dat het wel laagdrempelig is. Een commerci\xeble bijles kost al snel €35. \xc9n onze ervaring is zelfs dat de kwaliteit van de bijles van een leerling beter is dan die van de externe partij waar we eerst mee werkten. Leerlingen weten veel beter wat de stof is en wat belangrijk is, omdat ze zelf recente ervaring hebben.”"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "mt-8",
                                            children: "“Het is nog steeds niet gratis, maar dat is wel ons streven. De gemeente Breda is aan het kijken of ze hier iets mee kunnen doen. Zij hebben contact gezocht met onze school of ze een pilot kunnen draaien om het gratis aan te bieden. Dat proberen we vanuit de stichting Librēon* te doen. Daar zijn 14 scholen uit het voortgezet onderwijs in de regio Breda bij aangesloten. Hopelijk lukt dat voor volgend schooljaar. En wat ons betreft voor lange termijn. Met Bijlesplein hebben we een platform waarmee we dit heel makkelijk kunnen invoeren.”"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                            className: "mt-16 text-2xl font-bold tracking-tight text-gray-900",
                                            children: "Zou je Bijlesplein aanbevelen?"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "mt-8",
                                            children: "“Ja, in meerdere opzichten. Het scheelt veel administratie en daarmee tijd die in de kwaliteit van het onderwijs gestopt kan worden. En het is leuk en leerzaam voor leerlingen. Ze zijn zelf verantwoordelijk, gaan zelf opzoek, bekijken wat we wel en niet aanspreekt en onderhouden zelf het contact. Daar leren ze heel veel van.”"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "mt-8",
                                            children: "“Door de vrijgekomen tijd heb ik meer contact met leerlingen om de kwaliteit van de tutoring te verbeteren. Zo is het nu gelukt om samen met Fontys iets te organiseren om de kwaliteit te verbeteren. Je wil als school heel graag meehelpen om een bijles te geven en voor te bereiden. De tijd gaat meer daarnaartoe en is dus veel nuttiger besteedt wat mij betreft.”"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "mt-8",
                                            children: "“Bijlesplein denkt heel erg mee in vernieuwingen en ontwikkelingen. Je merkt dat ze de technische kennis in huis hebben. Zoals eerder al aangegeven zijn we aan het kijken om meldingen te sturen naar leerlingen die een mogelijk match hebben. Daarnaast willen we dat leerlingen een uitdraai kunnen maken per maand zodat ze een maandtikkie kunnen sturen bijvoorbeeld.”"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "mt-8",
                                            children: "“Er zijn kosten aan verbonden, maar dat is het zeker waard. Als je dit als school zelf zou willen ontwikkelen, ben je alleen aan ontwikkelingskosten al een vermogen kwijt. Het is heel gebruiksvriendelijk. Zo is het gelinkt aan magister. In ons geval is dat superhandig. Ik ben blij dat we Bijlesplein ontdekt hebben.”"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                            className: "mt-16 text-2xl font-bold tracking-tight text-gray-900",
                                            children: "Ook benieuwd naar de mogelijkheden van Bijlesplein voor jouw school?"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                            className: "mt-8",
                                            children: [
                                                "Neem ",
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_14___default()), {
                                                    href: "/contact",
                                                    children: "contact"
                                                }),
                                                " met ons op of vraag direct een ",
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_14___default()), {
                                                    href: "/demo",
                                                    children: "gratis demo"
                                                }),
                                                " aan."
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_CallToAction__WEBPACK_IMPORTED_MODULE_6__/* .CallToAction */ .J, {})
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Footer__WEBPACK_IMPORTED_MODULE_7__/* .Footer */ .$, {})
        ]
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [695,597,247,774,888,179], function() { return __webpack_exec__(3410); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);